"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseMapConnector = void 0;
const downloadFile_1 = __importDefault(require("@common/tsutils/downloadFile"));
const colors_1 = require("@common/tsutils/colors");
function addXYtoLatLong(val, dx, dy) {
    const R_EARTH = 6371000.0; // m
    const { lat, lon } = val;
    const newLat = lat + (dy / R_EARTH) * (180 / Math.PI);
    const newLon = lon + ((dx / R_EARTH) * (180 / Math.PI)) / Math.cos((lat * Math.PI) / 180);
    return { lat: newLat, lon: newLon };
}
function randomNumber(min, max) {
    return Math.random() * (max - min) + min;
}
class BaseMapConnector {
    constructor(config) {
        this.olMap = null;
        this.mapDivId = '';
        this.randomizeMarker = false;
        this.zoom = 7;
        this.config = config;
    }
    randomizeMarkerPosition(val) {
        this.randomizeMarker = val;
    }
    setDivId(id) {
        this.mapDivId = id;
    }
    async draw() {
        if (!this.olMap) {
            await this.drawMap();
        }
    }
    async forceDraw() {
        await this.drawMap();
    }
    async drawMap() {
        console.log('%cDraw map', 'background: #222; color: #bada55');
        // Retrieve the openlayers object
        const ol = this.getOpenLayers();
        // OpenStreetMaps as source
        const raster = this.newRaster();
        // Polygon layer
        this.polygons = new ol.Collection();
        const vector1 = new ol.layer.Vector({
            source: new ol.source.Vector({
                // defaultProjection: 'EPSG:4326',
                // projection: 'EPSG:3857',
                features: this.polygons,
            }),
        });
        // Marker layer
        this.markers = new ol.Collection();
        const vector2 = new ol.layer.Vector({
            source: new ol.source.Vector({
                features: this.markers,
            }),
        });
        /* Always start from usa */
        let inicoords = [-90.564266, 38.587557];
        inicoords = ol.proj.transform(inicoords, 'EPSG:4326', 'EPSG:3857');
        const zoom = this.zoom;
        const layers = Array.isArray(raster) ? [...raster, vector1, vector2] : [raster, vector1, vector2];
        this.olMap = new ol.Map({
            layers: layers,
            target: this.mapDivId,
            view: new ol.View({
                center: inicoords,
                zoom: zoom,
                maxZoom: 19,
            }),
        });
        // zoom defined
        if (document) {
            /*             if(document.getElementById('ol-zoom-in')) {
                document.getElementById('ol-zoom-in')!.addEventListener('click', () => {
                    this.olMap.getView().setZoom(this.olMap.getView().getZoom() + 1);
                    console.log('in');
                });
            }

            if(document.getElementById('ol-zoom-out')) {
                document.getElementById('ol-zoom-out')!.addEventListener('click', () => {
                    this.olMap.getView().setZoom(this.olMap.getView().getZoom() - 1);
                    console.log('out');
                });
            } */
            const overlay = document.querySelector('.overlay-container');
            const closer = document.querySelector('.overlay-close');
            const overlayLayer = new ol.Overlay({
                element: overlay,
            });
            this.olMap.addOverlay(overlayLayer);
            if (overlayLayer) {
                this.olMap.on('click', (e) => {
                    this.olMap.forEachFeatureAtPixel(e.pixel, (feature, layer) => {
                        overlayLayer.setPosition(e.coordinate);
                        this.olMap.addOverlay(overlayLayer);
                    });
                });
            }
            if (closer) {
                closer.addEventListener('click', (e) => {
                    overlayLayer.setPosition(undefined);
                    return false;
                });
            }
        }
    }
    newRaster() {
        // Retrieve the openlayers object
        const ol = this.getOpenLayers();
        if (this.config.provider === 'BingMaps') {
            return new ol.layer.Tile({
                source: new ol.source.BingMaps({
                    key: this.config.apikey,
                    imagerySet: 'AerialWithLabels',
                }),
            });
        }
        else if (this.config.provider === 'AzureMaps') {
            return [
                new ol.layer.Tile({
                    source: new ol.source.XYZ({
                        url: `https://atlas.microsoft.com/map/tile?api-version=2.1&tilesetId=microsoft.imagery&zoom={z}&x={x}&y={y}&subscription-key=${this.config.apikey}`,
                        tileSize: 256
                    })
                }),
                new ol.layer.Tile({
                    source: new ol.source.XYZ({
                        url: `https://atlas.microsoft.com/map/tile?api-version=2.1&tilesetId=microsoft.base.labels.road&zoom={z}&x={x}&y={y}&subscription-key=${this.config.apikey}`,
                        tileSize: 256
                    })
                })
            ];
        }
        else if (this.config.provider === 'OpenStreetMaps') {
            return new ol.layer.Tile({
                source: new ol.source.OSM(),
            });
        }
        else {
            throw new Error(`Not supported map provider: ${this.config.provider}`);
        }
    }
    /*
     * Get The open layers library
     */
    getOpenLayers() {
        // @ts-ignore
        const ol = window.ol;
        if (!ol) {
            throw new Error('Missing open layers library');
        }
        return ol;
    }
    reset() {
        // console.log('%cReset map', 'background: #222; color: #bada55');
        if (this.polygons)
            this.polygons.clear();
        if (this.markers)
            this.markers.clear();
    }
    drawPolygon(polygon) {
        const { color, gradient, dash, fill } = polygon;
        const ol = this.getOpenLayers();
        const wkt = polygon.shape;
        const format = new ol.format.WKT();
        const feature = format.readFeature(wkt, {
            dataProjection: 'EPSG:4326',
            featureProjection: 'EPSG:3857',
        });
        const styles = this.createPolygonStyles({ color, gradient, fill, dash });
        feature.setStyle(styles);
        //
        // // Generate a rainbow gradient
        // const canvas = document.createElement('canvas');
        // const context = canvas.getContext('2d')!;
        //
        // const extend = feature.getGeometry().getExtent();
        // console.log(extend);
        //
        // const pixels = this.olMap.getPixelFromCoordinate([extend[0], extend[1]]);
        //
        // console.log("pixels", pixels);
        //
        // const gradient = context.createLinearGradient(0, 0, 1024 * ol.has.DEVICE_PIXEL_RATIO, 0);
        // gradient.addColorStop(0, 'red');
        // gradient.addColorStop(0.1, 'green');
        // gradient.addColorStop(0.2, 'red');
        // gradient.addColorStop(0.3, 'green');
        // gradient.addColorStop(0.4, 'red');
        // gradient.addColorStop(0.5, 'green');
        // gradient.addColorStop(0.6, 'red');
        // gradient.addColorStop(0.7, 'green');
        // gradient.addColorStop(0.8, 'red');
        // gradient.addColorStop(0.9, 'green');
        // gradient.addColorStop(1, 'red');
        // console.log(gradient);
        //
        // const x = new ol.style.Style({
        //     stroke: new ol.style.Stroke({
        //         width: 4,
        //         color: gradient,
        //     }),
        // });
        // feature.setStyle(x);
        if (this.polygons)
            this.polygons.push(feature);
    }
    drawMarker(point) {
        const ol = this.getOpenLayers();
        let { lon, lat, color, text } = point;
        lat = parseFloat(lat + '');
        lon = parseFloat(lon + '');
        if (this.randomizeMarker) {
            const newLatLon = addXYtoLatLong({ lat, lon }, randomNumber(-5, 5), randomNumber(-5, 5));
            lat = newLatLon.lat;
            lon = newLatLon.lon;
        }
        const feature = new ol.Feature({
            geometry: new ol.geom.Point(ol.proj.transform([lon, lat], 'EPSG:4326', 'EPSG:3857')),
        });
        const styles = this.createIconStyles({ text, color });
        feature.set('name', text);
        feature.setStyle(styles);
        if (this.markers)
            this.markers.push(feature);
    }
    createIconStyles(config) {
        const ol = this.getOpenLayers();
        const defaults = {
            opacity: 1,
            iconPath: '/images/map/resources/test_marker.png',
            color: '#FFFFFF',
        };
        const { opacity, iconPath, text, color } = Object.assign(Object.assign({}, defaults), config);
        const styles = [];
        const iconStyle = new ol.style.Style({
            image: new ol.style.Icon({
                color: color,
                anchor: [7, 39],
                anchorXUnits: 'pixels',
                anchorYUnits: 'pixels',
                opacity: opacity,
                src: iconPath,
            }),
        });
        styles.push(iconStyle);
        if (text) {
            const textStyle = new ol.style.Style({
                text: new ol.style.Text({
                    rotation: -1.05,
                    text: text.substring(0, 8),
                    offsetX: -10,
                    offsetY: -15,
                    textAlign: 'left',
                    fill: new ol.style.Fill({
                        color: '#232323',
                    }),
                }),
            });
            styles.push(textStyle);
        }
        return styles;
    }
    createPolygonStyles(config) {
        const ol = this.getOpenLayers();
        const defaults = {
            color: '#FF333F',
            fill: '#FF333F',
            width: 5,
        };
        const { color, gradient, dash, width, fill } = Object.assign(Object.assign({}, defaults), config);
        const styles = [];
        // Fill
        let fixedColor = color || '#ffffff';
        const isRGB = fixedColor.match(/\,/g);
        if (fixedColor.length === 7) {
            fixedColor = fixedColor + '50';
        }
        else if (isRGB && isRGB.length === 2) {
            fixedColor = fixedColor.replace(')', ', 0.5)');
        }
        styles.push(new ol.style.Style({
            fill: new ol.style.Fill({
                color: fill || fixedColor,
            }),
        }));
        if (gradient) {
            const steps = 10;
            const circleFn = (x) => Math.sqrt(1 - x * x);
            for (let i = 0; i < steps; i++) {
                const mix = circleFn(i * (1 / steps));
                styles.push(new ol.style.Style({
                    stroke: new ol.style.Stroke({
                        color: (0, colors_1.colorMix)(gradient[0], gradient[1], 1 - mix),
                        width: ((steps - i) / steps) * width,
                    }),
                }));
            }
        }
        else if (dash) {
            styles.push(new ol.style.Style({
                stroke: new ol.style.Stroke({
                    color: dash[0],
                    width,
                }),
            }));
            styles.push(new ol.style.Style({
                stroke: new ol.style.Stroke({
                    color: dash[1],
                    width,
                    lineDash: [10, 20],
                }),
            }));
        }
        else {
            styles.push(new ol.style.Style({
                stroke: new ol.style.Stroke({
                    color,
                    width,
                }),
            }));
        }
        return styles;
    }
    center() {
        const geometries = [];
        if (this.polygons) {
            this.polygons.forEach((polygon) => {
                geometries.push(polygon.getGeometry());
            });
        }
        if (this.markers) {
            this.markers.forEach((marker) => {
                geometries.push(marker.getGeometry());
            });
        }
        if (!geometries.length) {
            return;
        }
        const all = new (this.getOpenLayers().geom.GeometryCollection)();
        all.setGeometries(geometries);
        this.olMap.getView().fit(all.getExtent(), { duration: 1000 });
    }
    updateCanvasSize(isSinking) {
        let zoomModifier = 1;
        if (isSinking)
            zoomModifier = -1;
        var self = this;
        setTimeout(function () {
            self.olMap.updateSize();
            self.olMap.getView().setZoom(self.olMap.getView().getZoom() + zoomModifier);
        }, 200);
        this.center();
    }
    zoomIn() {
        this.olMap.getView().setZoom(this.olMap.getView().getZoom() + 1);
    }
    zoomOut() {
        this.olMap.getView().setZoom(this.olMap.getView().getZoom() - 1);
    }
    download() {
        const mapDiv = document.getElementById(this.mapDivId);
        if (!mapDiv) {
            return;
        }
        const mapCanvas = document.createElement('canvas');
        const size = this.olMap.getSize();
        mapCanvas.width = size[0];
        mapCanvas.height = size[1];
        const mapContext = mapCanvas.getContext('2d');
        if (!mapContext)
            return;
        const currentCanvas = mapDiv.querySelectorAll('.ol-viewport canvas');
        Array.prototype.forEach.call(currentCanvas, function (canvas) {
            if (canvas.width > 0) {
                mapContext.drawImage(canvas, 0, 0);
            }
        });
        mapCanvas.toBlob(function (blob) {
            if (!blob)
                return;
            (0, downloadFile_1.default)(blob, 'map.png', 'image/png');
        });
    }
    downloadMapKML(fillColor, strokeColor, filename) {
        const ol = this.getOpenLayers();
        const format = new ol.format.KML();
        const features = [];
        if (this.markers) {
            this.markers.forEach((marker) => {
                const styles = this.createIconStyles({
                    text: marker.get('name'),
                    color: fillColor,
                    iconPath: new URL('/images/map/resources/test_marker.png', document.baseURI).href
                });
                marker.setStyle(styles);
                features.push(marker);
            });
        }
        if (this.polygons) {
            this.polygons.forEach((polygon) => {
                features.push(polygon);
            });
        }
        const kml = format.writeFeatures(features, {
            dataProjection: 'EPSG:4326',
            featureProjection: 'EPSG:3857',
        });
        const blob = new Blob([kml], { type: 'application/vnd.google-earth.kml+xml' });
        (0, downloadFile_1.default)(blob, `${filename}.kml`, 'application/vnd.google-earth.kml+xml');
    }
}
exports.BaseMapConnector = BaseMapConnector;
